<template>
  <div class="registration-page">
    <div class="registration-page-container">
      <div class="section">
        <div class="section-header">
          <h3>본인인증하기</h3>
        </div>
        <div class="section-body">
          <ul class="notice-text-list">
            <li class="notice-text">
              가입신청을 완료하신 후 아래의 방법 중 한가지로 본인인증을 하시기
              바랍니다. (인증 진행 후 인증하기 버튼 클릭)
            </li>
          </ul>

          <dl class="field-group">
            <dt class="field-label">
              인증수단선택
            </dt>
            <dd class="field-control">
              <div class="field-control-sub">
                <div
                        id="radio-button-container-id-verification-type-card"
                        class="input-container input-horizontal"
                >
                  <input
                          id="select-verification-type-card"
                          v-model="$store.state.step1.onetAutnDivsCd"
                          type="radio"
                          name="id-verification-type"
                          value="06"
                          class="input-radio"
                          title="본인인증수단 선택"
                  />
                  <label for="select-verification-type-card" class="input-label"
                  >신용카드인증</label
                  >
                </div>
                <!-- <div
                        id="radio-button-container-id-verification-type-auth"
                        class="input-container input-horizontal"
                        v-if="!($store.state.isMobile)"
                >
                  <input
                          id="select-verification-type-auth"
                          v-model="$store.state.step1.onetAutnDivsCd"
                          type="radio"
                          name="id-verification-type"
                          value="04"
                          class="input-radio"
                          title="본인인증수단 선택 범용공동인증 창 열림"
                  />
                  <label for="select-verification-type-auth" class="input-label"
                  >범용공동인증</label
                  >
                </div> -->
                <div
                        v-if="
                      openMarketInfo.registrationTypeCode === 'chg' ||
                      openMarketInfo.registrationTypeCode === 'renew'
                  "
                        id="radio-button-container-id-verification-type-mobile"
                        class="input-container input-horizontal"
                >
                  <!-- <div id="radio-button-container-id-verification-type-mobile" class="input-container input-horizontal"> -->
                  <input
                          id="select-verification-type-mobile"
                          v-model="$store.state.step1.onetAutnDivsCd"
                          type="radio"
                          name="id-verification-type"
                          value="03"
                          class="input-radio"
                          title="본인인증수단 선택"
                  />
                  <label
                          for="select-verification-type-mobile"
                          class="input-label"
                  >휴대폰인증</label
                  >
                </div>
                <!-- [C20230918_06754_4606754]온세일 인증수단 추가 건-->
                <div                   
                        id="radio-button-container-id-verification-type-pass"
                        class="input-container input-horizontal"
                >
                  <input
                          id="select-verification-type-pass"
                          v-model="$store.state.step1.onetAutnDivsCd"
                          type="radio"
                          name="id-verification-type"
                          value="10"
                          class="input-radio"
                          title="본인인증수단 간편인증 창 열림"
                  />
                  <label for="select-verification-type-pass" class="input-label">PASS</label>
                </div>
                <div    
                        id="radio-button-container-id-verification-type-naver"
                        class="input-container input-horizontal"
                >
                  <input
                          id="select-verification-type-naver"
                          v-model="$store.state.step1.onetAutnDivsCd"
                          type="radio"
                          name="id-verification-type"
                          value="11"
                          class="input-radio"
                          title="본인인증수단 간편인증 창 열림"
                  />
                  <label for="select-verification-type-naver" class="input-label">네이버</label>
                </div>
                <div    
                        id="radio-button-container-id-verification-type-toss"
                        class="input-container input-horizontal"
                >
                  <input
                          id="select-verification-type-toss"
                          v-model="$store.state.step1.onetAutnDivsCd"
                          type="radio"
                          name="id-verification-type"
                          value="12"
                          class="input-radio"
                          title="본인인증수단 간편인증 창 열림"
                  />
                  <label for="select-verification-type-toss" class="input-label">토스</label>
                </div>                
                <!-- [ST] KAKAO추가 2025-06-30 -->
                <div    
                        id="radio-button-container-id-verification-type-kakao"
                        class="input-container input-horizontal"
                >
                  <input
                          id="select-verification-type-kakao"
                          v-model="$store.state.step1.onetAutnDivsCd"
                          type="radio"
                          name="id-verification-type"
                          value="13"
                          class="input-radio"
                          title="본인인증수단 간편인증 창 열림"
                  />
                  <label for="select-verification-type-kakao" class="input-label">카카오</label>
                </div> 
                <!-- [ED] KAKAO추가 2025-06-30 -->
              </div>

              <div class="field-control-sub">
                <dl class="field-control-sub sub-form m-input-half">
                  <dt>
                    <label
                            id="id-verification-input-name"
                            class="input-sub-text w120 mw100"
                    >이름</label
                    >
                  </dt>
                  <dd>
                    <input
                            for="id-verification-input-name"
                            type="text"
                            @input="onlyText"
                            name="lgdBuyer"
                            placeholder="이름"
                            v-model="retrieveData.lgdBuyer"
                            class="input-text input-width-medium input-font"
                            title="성명입력"
                    />
                  </dd>
                </dl>
              </div>
              <div v-if="$store.state.step1.onetAutnDivsCd === '06' ||
                         $store.state.step1.onetAutnDivsCd === '04' || 
                         $store.state.step1.onetAutnDivsCd === '03'"  
                         class="field-control-sub">
                <dl class="field-control-sub sub-form m-input-half">
                  <dt>
                    <label
                            id="id-verification-input-birthdate"
                            class="input-sub-text w120 mw100"
                    >생년월일</label
                    >
                  </dt>
                  <dd>
                    <input
                            for="id-verification-input-birthdate"
                            type="text"
                            autocomplete="off"
                            placeholder="6자리입력"
                            v-model="retrieveData.lgdPrivateno"
                            @input="onlyNumber"
                            name="lgdPrivateno"
                            maxlength="6"
                            class="input-text input-width-medium input-font"
                            title="생년월일 6자리 입력"
                    />
                  </dd>
                </dl>
              </div>
              <div
                      v-if="$store.state.step1.onetAutnDivsCd === '06'"
                      class="field-control-sub"
              >
                <dl class="field-control-sub sub-form m-input-half">
                  <dt>
                    <label
                            for="verification-card-number"
                            class="input-sub-text w120 mw100"
                    >카드번호</label
                    >
                  </dt>
                  <dd>
                    <input
                            id="verification-card-number"
                            type="text"
                            name="cardNo"
                            ref="ref_cardNo"
                            maxlength="6"
                            autocomplete="off"
                            placeholder="'-'없이 앞 6자리 입력하세요"
                            v-model="kcbInfo.cardNo"
                            @input="onlyNumber2"
                            class="input-text input-width-small input-font"
                            title="본인인증 가능한 신용카드 번호 입력"
                    />
                  </dd>
                  <span class="input-sub-text">**-****-**** (앞 6자리)</span>
                </dl>

                <dl class="field-control-sub sub-form m-input-col">
                  <dd>
                    <!-- <span class="field-group-space"></span> -->
                    <button
                            type="submit"
                            class="m-right mw100"
                            @click="cardValidation"
                    >
                      인증하기
                    </button>
                  </dd>
                </dl>
              </div>

              <!-- <div
                      v-if="$store.state.step1.onetAutnDivsCd === '04'"
                      class="field-control-sub"
              >
                <dl>
                  <dt class="blind">범용공동인증하기</dt>
                  <dd>
                    <button
                            type="button"
                            title="공동인증모듈 호출"
                            class="m-right mw100"
                            @click="kmcValidation"
                    >
                      인증하기
                    </button>
                  </dd>
                </dl>
              </div> -->

              <div
                      v-if="$store.state.step1.onetAutnDivsCd === '03'"
                      class="field-control-sub"
              >
                <dl class="field-control-sub sub-form m-input-half">
                  <dt>
                    <label
                            for="verification-phonenumber"
                            class="input-sub-text w120 mw100"
                    >휴대폰번호</label
                    >
                  </dt>
                  <dd>
                    <input
                            id="verification-phonenumber"
                            type="text"
                            @input="onlyNumber"
                            name="phoneNo"
                            autocomplete="off"
                            v-model="retrieveData.phoneNo"
                            placeholder="'-' 없이 입력하세요"
                            class="input-text input-width-medium input-font"
                            title="본인인증할 휴대폰 번호 입력"
                            maxlength="11"
                    /><button type="button" @click="getVerificationNumber">
                    인증번호 발송
                  </button>
                  </dd>
                </dl>
                <dl class="field-control-sub sub-form m-input-half ml0">
                  <dt>
                    <label
                            for="verification-receieved-code-number"
                            class="input-sub-text w120 mw100"
                    >인증번호입력</label
                    >
                  </dt>
                  <dd>
                    <input
                            id="verification-receieved-code-number"
                            type="text"
                            @input="onlyNumber"
                            name="smsval"
                            autocomplete="off"
                            v-model="retrieveData.smsval"
                            maxlength="6"
                            class="input-text input-width-medium input-font "
                    /><button type="submit" class="" @click="hpVerification">
                    인증하기
                  </button>
                  </dd>
                </dl>
              </div>
              <!--통합인증하기 시작-->
              <div
                      v-if="$store.state.step1.onetAutnDivsCd === '10'||
                            $store.state.step1.onetAutnDivsCd === '11'||
                            $store.state.step1.onetAutnDivsCd === '12'||
                            $store.state.step1.onetAutnDivsCd === '13'"
                      class="field-control-sub"
              >
               <dl class="field-control-sub sub-form m-input-half">
                  <dt>
                    <label
                            id="id-verification-input-birthdate"
                            class="input-sub-text w120 mw100"
                    >생년월일</label
                    >
                  </dt>
                  <dd>
                    <input
                            for="id-verification-input-birthdate"
                            type="text"
                            autocomplete="off"
                            placeholder="8자리입력"
                            v-model="birthday"
                            @input="onlyNumber"
                            name="birthday"
                            maxlength="8"
                            class="input-text input-width-medium input-font"
                            title="생년월일 8자리 입력"
                    />
                  </dd>
                </dl>
               <dl class="field-control-sub sub-form m-input-half">
                  <dt>
                    <label
                            for="verification-phonenumber"
                            class="input-sub-text w120 mw100"
                    >휴대폰번호</label
                    >
                  </dt>
                  <dd>
                    <input
                            id="verification-phonenumber"
                            type="text"
                            @input="onlyNumber"
                            name="phoneNo"
                            autocomplete="off"
                            v-model="retrieveData.phoneNo"
                            placeholder="'-' 없이 입력하세요"
                            class="input-text input-width-medium input-font"
                            title="본인인증할 휴대폰 번호 입력"
                            maxlength="11"
                    />
                  </dd>
                </dl>
                <dl class="field-control-sub sub-form m-input-col">
                  <dt></dt>
                  <dd>
                    <button
                            type="button"
                            title="통합인증 호출"
                            class="m-right mw100"
                            @click="inicisValidation"
                    >
                      인증하기
                    </button>
                  </dd>
                </dl>
              </div>
              <!--통합인증하기 끝-->
              <div class="field-control-sub">
                <ul class="notice-text-list">
                  <div v-if="this.IOS">
                    <li class="notice-text">
                      <em class="primary-text">아이폰을 이용하시는 고객님은 사전에  팝업차단 해제 후 이용하세요. (해제방법:설정>Safari>팝업차단)</em>
                    </li>
                  </div>
                  <li class="notice-text">
                    전자 서명법에 따라 용도제한 공동인증서(은행용 구 공인인증서등)로는 이용이 불가함을 양해해주시기 바랍니다.
                  </li>
                  <li class="notice-text">
                    <em class="primary-text">본인인증 후 해당서류를 FAX접수해 주시기 바랍니다.</em>
                    (신분증 사본 / 청소년일 경우 부모님의 신분증 및 가족관계증명서 또는 주민등록 등본)
                  </li>
                </ul>
              </div>
            </dd>
          </dl>
        </div>
      </div>
      <!-- 임시 -->
      <!-- <div class="step-bottom-area input-wrap">
        <button class="primary-button mw100 pc-float-right" @click="go">
          다음(임시)
        </button>
      </div> -->
      <!-- 임시 -->
    </div>
    <v-dialog />
  </div>
</template>

<script>
  import { createAppFormEndding } from '@/api/captureService'
  import {
    smsAuthSend,
    smsAuthCheck,
    callKcbPopup,
    saveKcbCardAuthInfo,
    getKcbCardAuthInfo,
    callKmcPublAuthPopup,
    callInicisPopup,

  } from '@/api/step3/identificationVerfication'

  import {callNormalPopup} from '@/api/common'

  //[ST][CSR:RITM2694040] 안면인증 1차 시범서비스
  import { requestFaceAuthAltInfo } from '@/api/openmarket' //안면인증 세컨디바이스 처리
  //[ED][CSR:RITM2694040] 안면인증 1차 시범서비스

  export default {
    name: 'IdentityVerificationSection_samsung',
    data() {
      return {
        registration: {
          dcntKdNm: '', // 할인유형명
          pymnBday: '', // 납부자생년월일
          appfNo: '', //신청서번호
          crypAppfNo: '', // 암호화 신청서번호
          rqstPgrsStusNm: '', //신청진행상태명
          onetKdCd: '', //가입유형코드
          onetKdNm: '', //가입유형명
          ppCd: '', //요금제코드
          sppsProdCdCntn: '', //부가서비스상품코드내용
          dataPpCd: '', //데이터요금제코드
          custKdCd: '', //고객유형코드
          aplcNm: '', //신청자명
          aplcDerno: '', //신청자주민등록번호--------------->최초
          aplcDernoMask: '', //신청자주민등록번호--------------->마스킹
          aplcTlno: '', //신청자전화번호
          aplcEmalAddr: '', //신청자이메일주소
          bltxRcepMthdCd: '', //청구서수령방법코드
          billDivsCd: '', //청구구분코드
          crplZpcd: '', //청구지우편번호
          crplAddr: '', //청구지주소
          crplDadr: '', //청구지상세주소
          pymnDivsCd: '', //납부자구분코드 TODO 본인:1 / 타인:2
          pymnNm: '', //납부자명 TODO 청소년이면 대리인
          pymnDerno: '', //납부자주민등록번호--------------->최초 TODO 청소년이면 대리인
          pymnEmalAddr: '', //납부자이메일주소 TODO 청소년이면 대리인
          paymMthdDivsCd: '', //납부방법구분코드
          bankNm: '', //은행명
          CdcoNm: '', //카드사명
          onetBankCd: '', //온라인가입은행코드
          onetCdcoCd: '', //온라인가입카드사코드
          acctCardNo: '', //계좌카드번호--------------->화면보기
          acctCardNoMask: '', //계좌카드번호마스킹
          ccrdValdTermEndYymm: '', //신용카드유효기간종료년월
          wdrwAgrYn: '', //출금동의여부
          mnpSoacTrgtCd: '', //번호이동정산대상코드
          mnpSoacNo: '', //번호이동정산번호
          noRnftEnprCd: '', //번호이동전사업자코드
          trmSrno: '', //단말시리얼번호
          dvicMdlCd: '', //단말기모델코드
          dvicMdlNm: '', //단말기모델명
          dvicColrCd: '', //단말기색상코드
          hphnColrNm: '', //휴대폰색상명
          chgHopTlno: '', //변경희망전화번호
          crgrBuyYn: 'N', //충전기구매여부
          ppNm: '', //요금제명
          dataPpNm: '', //데이터요금제명
          sppsProdNmCntn: '', //부가서비스상품명내용
          adltCntsIsolRqstYn: '', //성인컨텐츠차단신청여부
          agntEntrRstnYn: '', //대리인가입제한여부
          lawcAgntNm: '', //법정대리인명
          decLawcAgntCrypRrno: '', //------->입력
          lawcAgntCrypRrnoMask: '', //법정대리인암호화주민등록번호마스킹
          lawcAgntTlno: '', //법정대리인전화번호
          lawcAgntZpcd: '', //법정대리인우편번호
          lawcAgntAddr: '', //법정대리인주소
          lawcAgntDadr: '', //법정대리인상세주소
          isttTermMmct: '24', //할부기간개월수 halbuMonth
          tinsAmt: '0', //총할부금액 halbuPrice
          adseRqstDivsCd: '', //선결제신청구분코드
          lssInsrDivsNm: '', //분실보험구분명
          dcntDivsCd: '', //할인구분코드
          dcntTermMmct: '', //할인기간개월수 =agreedMonthM2M / discMonth
          dcntKdCd: '', //할인유형코드
          agmtTermMmct: '0', //약정기간개월수
          onsaAplyPlnNm: '', //온라인가입지원적용플랜명
          iphnUseAgrYn: '', //아이폰사용동의여부
          nwIsolYn: '', //네트워크차단여부
          entrAppfDvrMthdCd: '', //가입신청서교부방법코드
          entrAppfDvrMthdNm: '', //가입신청서교부방법명
          dlvRcipNm: '', //배송수령자명
          dlplZpcd: '', //배송지우편번호
          dlplBadr: '', //배송지기본주소
          dlplDadr: '', //배송지상세주소
          dlplTlno: '', //배송지전화번호
          dlvCtplNm: '', //배송연락처명
          custInfoGthrAgrYn: '', //고객정보수집동의여부
          pnifPuseTrstAgrYn: '', //개인정보활용위탁동의여부
          locFndnInfoOfrSvcAgrYn: '', //위치기반정보제공서비스동의여부
          autnMthdDivsCd: '', //인증방법구분코드
          prmsLinePcnt: '', //허용회선개수
          addReqMttrCntn: '', //추가요청사항내용
          dutyAgmtSuptAmt: '0', //의무약정지원금액 =dutyAgmtSuptAmt
          hphnInitStlmAmt: '', //휴대폰초기결제금액
          lssInsrCnslAgrYn: '', //분실보험상담동의여부
          dutyAgmtAgrYn: 'N', //의무약정동의여부 agreedAgreeYn
          rqstSppsCdCntn: '', //신청부가서비스코드내용
          dealAgmtAmt: '0', //대리점약정금액
          custBday: '', //고객생년월일
          lawcAgntAgrYn: '', //법정대리인동의여부
          smatAppUseYn: '', //스마트APP사용여부
          bukeAppUseYn: '', //사업지키미APP사용여부f
          rotrRqstYn: '', //라우터신청여부 formRoutrYn
          rotrAgmtMmct: '0', //라우터약정개월수
          rotrAgmtAmt: '0', //라우터약정금액
          browDivsCd: '', //브라우저구분코드
          rqstSppsNmCntn: '', //신청부가서비스명내용
          entrRqstFomNo: '', //가입신청양식번호
          opmkNo: '', //오픈마켓번호
          onlnAppfNo: '', //온라인신청서번호
          sbgnPosCd: '', //개통POS코드
          sbgnDealCd: '', //개통대리점코드
          dealNm: '', //대리점명
          opmkNm: '', //오픈마켓명
          svcDivsCd: '', //서비스구분코드
          shpnEntrRqstYn: '' //중고폰가입신청여부
        },
        retrieveData: {
          lgdBuyer: '', // 고객이름
          lgdPrivateno: '', // 생년월일
          lgdPan: '', // 카드번호
          lgdExpyear: '', // 년도
          lgdExpmon: '', // 월
          lgdPin: '', // 카드 비밀번호
          dealCd: '', // 대리점 번호
          onetMblAppfNo: '', // 신청서 번호
          phoneNo: '', // 휴대폰 번호
          smsval: '', // 인증번호 결과
          miltaryAgentYn: '',
        },
        kcbInfo:{
          rsltName: '',
          rsltBirthday: '',
          cardNo: '',
          miltaryAgentYn: '',
          onetMblAppfNo: '',
          crdCd:'',
          crdNm:'',
          txSeqNo:'',
          rsltSexCd:'',
          rsltNtvFrnrCd:'',
          ciRqstDttm:'',
          rsltCd: '',
          rsltMsg: ''
        },
        verificationCheck: false,
        cardNo: '',
        mdlTkn:'',
        birthday:'',
        openMarketInfo:{},
        result:{},
        //[ST][CSR:RITM2694040] 안면인증 세컨디바이스, 불허매장 처리
        sdevYn:'',
        faceAllSkipYn: '',
        faceNewSkipYn: '',
        faceMoveSkipYn: '',
        faceChgSkipYn: '',
        faceRenewSkipYn: '',
        formM2MYn: '',
        faceAutnIdcdSkip: false,
        facePosCdSkipYn: ''
        //[ED][CSR:RITM2694040] 안면인증 세컨디바이스, 불허매장 처리
      }
    },
    computed: {
// 모바일 에이전트 구분

      Android: function () {
        return navigator.userAgent.match(/Android/i) == null ? false : true;
      },
      BlackBerry: function () {
        return navigator.userAgent.match(/BlackBerry/i) == null ? false : true;
      },
      IOS: function () {
        return navigator.userAgent.match(/iPhone|iPad|iPod/i) == null ? false : true;
      },
      Opera: function () {
        return navigator.userAgent.match(/Opera Mini/i) == null ? false : true;
      },
      Windows: function () {
        return navigator.userAgent.match(/IEMobile/i) == null ? false : true;
      },


    },
    components: {},
    created() {
      this.initPage()
      // 대리점 코드, 신청서 번호
      this.retrieveData.dealCd = this.openMarketInfo.dealCd
      this.retrieveData.onetMblAppfNo = this.registration.appfNo
    },
    mounted() {
      this.$store.state.processIndicator.step1 = false
      this.$store.state.processIndicator.step2 = false
      this.$store.state.processIndicator.step3 = true
      this.$store.state.processIndicator.step4 = false
    },
    methods: {
      /**
       * Function    : onlyNumber
       * Description : input값 숫자 체크
       **/
      onlyNumber(e) {
        this.retrieveData[e.target.name] = e.target.value.replace(/[^0-9]/gi, '')
      },

      /**
       * Function    : onlyNumber2
       * Description : input값 숫자 체크
       **/
      onlyNumber2(e) {
        this.kcbInfo[e.target.name] = e.target.value.replace(/[^0-9]/gi, '')
      },
      /**
       * Function    : onlyText
       * Description : input값 텍스트 체크
       **/
      onlyText(e) {
        this.retrieveData[e.target.name] = e.target.value.replace(/[^ㄱ-ㅎ가-힣a-zA-Z0-9_@*/+.\s]/gi, '')
      },

      /**
       * Function    : initPage
       * Description : 본인인증 초기값 세팅
       **/
      initPage() {
        this.registration = this.$route.params.registration
        this.openMarketInfo = this.$route.params.openMarketInfo
        //[ST][CSR:RITM2694040] 안면인증 세컨디바이스, 불허매장 처리
        this.sdevYn = this.$route.params.sdevYn
        this.faceAllSkipYn = this.$route.params.faceAllSkipYn
        this.faceNewSkipYn = this.$route.params.faceNewSkipYn
        this.faceMoveSkipYn = this.$route.params.faceMoveSkipYn
        this.faceChgSkipYn = this.$route.params.faceChgSkipYn
        this.faceRenewSkipYn = this.$route.params.faceRenewSkipYn
        this.formM2MYn = this.$route.params.formM2MYn
        this.faceAutnIdcdSkip = this.$route.params.faceAutnIdcdSkip
        this.facePosCdSkipYn = this.$route.params.facePosCdSkipYn    
        //[ST][CSR:RITM2694040] 안면인증 세컨디바이스, 불허매장 처리
      },

      /**
       * Function    : cardValidation
       * Description : 신용카드 인증 시 Validation - 안내메시지 추가로 기존로직에서 분리
       **/
      cardValidation() {
        let title = '신용카드인증' 
        if(this.retrieveData.lgdBuyer.length < 1) {
          this.openAlertTemp(title,"이름을 입력해 주십시요");
          return;
        }

        if(this.retrieveData.lgdPrivateno.length < 6) {
          this.openAlertTemp(title,"생년월일 6자리를 입력해 주십시요");
          return;
        }

        if(this.kcbInfo.cardNo.length < 6) {
          this.openAlertTemp(title,"카드번호 앞 6자리를 입력해 주십시요");
          return;
        }
        this.openAlertPreTemp('card')
      },

      /**
       * Function    : cardVerification
       * Description : 신용카드 인증
       **/
      cardVerification() {

/*
        if(this.retrieveData.lgdBuyer.length < 1) {
          this.openAlertTemp(title, "이름을 입력해 주십시요");
          return;
        }

        if(this.retrieveData.lgdPrivateno.length < 6) {
          this.openAlertTemp(title, "생년월일 6자리를 입력해 주십시요");
          return;
        }

        if(this.kcbInfo.cardNo.length < 6) {
          this.openAlertTemp(title, "카드번호 앞 6자리를 입력해 주십시요");
          return;
        }
*/

        let title = '신용카드인증'
        this.kcbInfo.rsltName = this.retrieveData.lgdBuyer;
        this.kcbInfo.rsltBirthday = this.retrieveData.lgdPrivateno;
        this.kcbInfo.miltaryAgentYn = this.openMarketInfo.miltaryAgentYn;
        this.kcbInfo.onetMblAppfNo = this.registration.crypAppfNo;

        getKcbCardAuthInfo(this.kcbInfo).then(res => {

          this.result = res.data
          //   console.log(this.result.resCode)
          if( this.result.resCode === "SUCCESS") {
            this.mdlTkn = this.result.mdlTkn
            this.kcbInfo.cardKndCd= this.result.cardKndCd
            this.kcbInfo.dealCd= this.result.dealCd
            //   console.log(this.mdlTkn);
            this.callKcbPopup(title)
          } else {
            this.openAlertTemp(title,this.result.resMsg)

          }

        } )

      },

      /**
       * Function    : hpVerification
       * Description : 휴대폰 인증하기
       **/
      hpVerification() {
        let title = '휴대폰인증'
        smsAuthCheck(this.retrieveData).then(res => {
          let resultCd = res.data.dsRsltInfo.rsltCd
          let resultMsg = res.data.dsRsltInfo.rsltMsg
          if (resultCd === 'SUCCESS') {
            this.verificationCheck = true
            this.openAlert(title, resultMsg)
          } else {
            this.openAlertTemp(title, resultMsg)
          }
        })
      },

      /**
       * Function    : getVerificationNumber
       * Description : 휴대폰 번호 인증번호 발송
       **/
      getVerificationNumber() {
        let hpRegx = /^(?:(010\d{4})|(01[1|6|7|8|9]\d{3,4}))(\d{4})$/
        let title = '휴대폰인증'
        if (hpRegx.test(this.retrieveData.phoneNo)) {
          smsAuthSend(this.retrieveData).then(res => {
            let resultCd = res.data.dsRes.msgCd
            let resultMsg = res.data.dsRes.msg
            if (resultCd === 'SUCCESS') {
              this.openAlertTemp(title, resultMsg)
              this.retrieveData.pAuthKey = res.dsRes.testReturn
            } else {
              this.openAlert(title, resultMsg)
            }
          })
        } else {
          this.openAlertTemp(title, '휴대폰 번호를 확인해 주세요.')
        }
      },

      /**
       * Function    : authVerification
       * Description : 범용 공인인증
       **/
      authVerification() {

        if(this.retrieveData.lgdBuyer.length < 1) {
          this.openAlertTemp(title, "이름을 입력해 주십시요");
          return;
        }

        if(this.retrieveData.lgdPrivateno.length < 6) {
          this.openAlertTemp(title, "생년월일 6자리를 입력해 주십시요");
          return;
        }

        let title = '공용인증'
        let reqData = {
          custNm: this.retrieveData.lgdBuyer,
          custPersId: this.retrieveData.lgdPrivateno,
          onetMblAppfNo: this.registration.crypAppfNo,
          pymnDivsCd: this.registration.pymnDivsCd
        }
        callNormalPopup(reqData).then(res => {
          // 공인인증 팝업이 열리고, 리턴데이터를 받는다.
          let response = JSON.parse(res)
          if (response.rsltCd === 'SUCCESS') {
            // alert(response.dsRes.birth)
             if(response.dsRes.name===reqData.custNm 
                &&response.dsRes.birth===reqData.custPersId ){

                this.verificationCheck = true
                this.openAlert(title, response.rsltMsg)
             }else{
               this.openAlertTemp(title, "인증 정보와 요청 정보가 일치하지 않습니다. 재요청 해주시기 바랍니다.")
             }
            // this.$router.push({
            //   name: 'RegistrationStep4'
            // })
            
          } else {
            this.openAlertTemp(title, response.rsltMsg)
          }
        })
      },

      /** 
       * Function    : kmcValidation
       * Description : 범용 공인인증(Kmc)Validation - 안내메시지 추가로 기존로직에서 분리
       **/
      kmcValidation() {
        
        let title = '범용공인인증'
        
        if(this.retrieveData.lgdBuyer.length < 1) {
          this.openAlertTemp(title, "이름을 입력해 주십시요");
          return;
        }

        if(this.retrieveData.lgdPrivateno.length < 6) {
          this.openAlertTemp(title, "생년월일 6자리를 입력해 주십시요");
          return;
        }
        this.openAlertPreTemp('kmc')      
      },

      /** 
       * Function    : kmcPublAuth
       * Description : 범용 공인인증 Kmc 호출[C20230630_99755_4599755]공인인증 오픈마켓사용 2023.07.11 장희정 추가
       **/
      kmcPublAuth() {
        
        let title = '공용인증'
/*        
        if(this.retrieveData.lgdBuyer.length < 1) {
          this.openAlertTemp(title, "이름을 입력해 주십시요");
          return;
        }

        if(this.retrieveData.lgdPrivateno.length < 6) {
          this.openAlertTemp(title, "생년월일 6자리를 입력해 주십시요");
          return;
        }
*/

          let params = {
            custNm: this.retrieveData.lgdBuyer,
            custPersId: this.retrieveData.lgdPrivateno,
            onetMblAppfNo: this.registration.crypAppfNo
          }
          callKmcPublAuthPopup(params).then(res => {
            // 공인인증 팝업이 열리고, 리턴데이터를 받는다.
         // let response = JSON.parse(res)
        // alert(res)
          if (res === 'SUCCESS') {
                this.verificationCheck = true
                this.openAlert(title, "인증 되었습니다.")
 
          } else {
            this.openAlertTemp(title, "인증처리중 오류가 발생했습니다")
          }
          

        })
        
      },

      /**
       * Function    : openAlert
       * Description : 최종저장까지 하는 alert 호출 함수
       **/
      openAlert(title, message) {
        this.$modal.show('dialog', {
          title: title,
          text: message,
          buttons: [
            {
              title: '확인',
              class: 'primary-button',
              handler: () => {
                this.$modal.hide('dialog')
                if (this.verificationCheck) {
                  //[ST][CSR:RITM2694040] 안면인증 세컨디바이스, 카메라 불허매장 처리 (안면인증 Skip처리하는 아래경우에는 MIS 콜 하지 않음)                  
                  //외국인이 아니고                  
                  //전체 Skip이 아니고      ( FACE_ALL_SKIP : N)
                  //신규신청서 Skip이 아니고 ( FACE_NEW_SKIP : N)
                  //번이신청서 Skip이 아니고 ( FACE_MOVE_SKIP : N)
                  //기변신청서 Skip이 아니고 ( FACE_CHG_SKIP : N)
                  //재가입신청서 Skip이 아니고 ( FACE_RENEW_SKIP : N)
                  //본인인증이 주민증, 운전면허증이고                 
                  //M2M신청서가 아닐경우
                                    
                  // 세컨디바이스 또는 카메라 불허매장이고 위의 안면인증 Skip 처리 상태가 아닐 경우만 세컨디바이스 MIS호출 처리
                  if( this.sdevYn === 'Y' || this.facePosCdSkipYn === 'Y'){

                    if( this.registration.custKdCd != 'D' //외국인이 아니고
                        && this.faceAllSkipYn != 'Y'      //전체Skip 아니고
                        && !(this.openMarketInfo.opmkEntrKdCd === 'new' && this.faceNewSkipYn === 'Y')
                        && !(this.openMarketInfo.opmkEntrKdCd === 'move' && this.faceMoveSkipYn === 'Y')
                        && !(this.openMarketInfo.opmkEntrKdCd === 'chg' && this.faceChgSkipYn === 'Y') //기변 chg 사용안함
                        && !(this.openMarketInfo.opmkEntrKdCd === 'renew' && this.faceRenewSkipYn === 'Y')                        
                        && this.faceAutnIdcdSkip === false //본인인증 구분이 주민증, 운전면허증이고
                        && this.formM2MYn != 'Y'          //M2M신청서가 아닐 경우
                    ){
                      let sendSmsTlno = ''  //법정대리인 전화번호 처리

                      if( this.registration.lawcAgntAgrYn === 'Y' ){
                        sendSmsTlno = this.registration.lawcAgntTlno
                      }else{
                        sendSmsTlno = this.registration.aplcTlno
                      }

                      let reasonCd = '' //안면인증 대체사유코드

                      if( this.facePosCdSkipYn === 'Y'){
                        reasonCd = 'NC' //카메라 불허매장
                      }else{
                        reasonCd = 'SD' //세컨디바이스
                      }
                                          
                      //대체사유처리(세컨디바이스:SD, 카메라불허매장:NC)
                      requestFaceAuthAltInfo(this.registration.crypAppfNo, 'SAMS', sendSmsTlno, this.openMarketInfo.sbgnPosCd, this.openMarketInfo.agentId, this.openMarketInfo.sbgnPosCd, reasonCd).then(res => {
                        this.save()                    
                      })
                    }else{
                      this.save()  
                    }

                  }else{
                    this.save()  
                  }
                }
              }
            }
          ]
        })
      },

      /**
       * Function    : openAlertTemp
       * Description : 기본 alert 호출 함수
       **/
      openAlertTemp(title, message, ref) {
        this.$modal.show('dialog', {
          text: message,
          title: title,
          buttons: [
            {
              title: '확인',
              class: 'primary-button',
              handler: () => {
                if (ref) {
                  ref.focus()
                }
                this.$modal.hide('dialog')
              }
            }
          ]
        })
      },

      /**
       * Function    : openAlertPreTemp
       * Description : 본인인증 인증하기 alert(참고사항 안내)
       **/
      openAlertPreTemp(ref) {
        let tagTitle = "<div style='text-align:center;'>본인인증 화면으로 이동합니다.</div>";  
        this.$modal.show('dialog', {
          text: "선택하신 인증수단 화면으로 이동합니다. <br>인증 중 실패나 오류/지연이 발생하더라도 작성 중인 내용은 자동 저장되며, 재인증 시 이용약관 및 실명확인 단계부터 이어서 진행 됩니다.",          
          title: tagTitle,
          buttons: [
            {
              title: '확인',
              class: 'primary-button',
              handler: () => {
                if (ref && ref == "card") {
                  this.cardVerification()
                }else if (ref && ref == "kmc"){
                  this.kmcPublAuth()  
                }else if (ref && ref == "inicis"){
                  this.inicisVerification()  
                }
                this.$modal.hide('dialog')
              }
            }
          ]
        })
      },      

      /**
       * Function    : save
       * Description : 최종 저장 함수
       **/
      save() {
        this.$modal.hide('dialog')

        this.registration.mobileRegistrationCaptureDetail.onetAutnDivsCd=this.$store.state.step1.onetAutnDivsCd

        Object.assign(this.registration, {autnMthdDivsCd:this.$store.state.step1.autnMthdDivsCd})
        createAppFormEndding(this.registration).then(res => {
          let dsRes = res.data.dsRes
          if (dsRes.msgCd === 'SUCCESS') {
            this.$modal.show('dialog', {
              title: '최종저장 성공',
              text: dsRes.msg,
              buttons: [
                {
                  title: '확인',
                  class: 'primary-button',
                  handler: () => {
                    this.$modal.hide('dialog')
                    this.$router.push({
                      name: 'RegistrationStep4_samsung'
                    })
                  }
                }
              ]
            })
          } else {
            this.openAlertTemp('최종저장 실패', dsRes.msg)
          }
        })
      },

      /**
       * Function    : callKcbPopup
       * Description : KCB 팝업 call
       **/
      callKcbPopup(title) {
        callKcbPopup(this.mdlTkn).then(res => {
          this.kcbInfo.mdlTkn = res;
          this.saveKcbResult(title);

        }).catch(error => {
          //  alert(error)
          this.openAlertTemp(title, '인증을 실패 했습니다.\n다시 시도해주세요.')
        })


      },
      /**
       * Function    : saveKcbResult
       * Description : KCB 팝업 결과 저장
       **/
      saveKcbResult(title) {

        saveKcbCardAuthInfo(this.kcbInfo).then(res => {
          if(res.data.dsRsltInfo.rsltCd === "SUCCESS") {
            let returnValue = {
              rsltCd: "SUCCESS",
              rsltMsg: res.data.dsRsltInfo.rsltMsg
            }
            this.verificationCheck = true
            this.openAlert(title, res.data.dsRsltInfo.rsltMsg)
          } else {
             /* let rsltMsg=res.data.dsRsltInfo.rsltMsg
              if(!rsltMsg){
                  rsltMsg ='인증을 실패 했습니다.\n다시 시도해주세요.'
              }*/
              this.openAlertTemp(title, '인증을 실패 했습니다.\n다시 시도해주세요.')
          }
        })
      },

      /**
       * Function    : inicisValidation
       * Description : 통합인증 Validation - 안내메시지 추가로 기존로직에서 분리
       **/
      inicisValidation() {
         let title = '통합인증'

         if(this.retrieveData.lgdBuyer.length < 1) {
          this.openAlertTemp(title, "이름을 입력해 주십시요");
          return;
        }

        if(this.birthday.length < 8) {
          this.openAlertTemp(title, "생년월일 8자리를 입력해 주십시요");
          return;
        }

         if(this.retrieveData.phoneNo.length < 1) { //휴대폰번호 null체크 추가
          this.openAlertTemp(title, "휴대폰번호를 입력해 주십시요");
          return;
        }

        if (!/^01[016789]\d{7,8}$/.test(this.retrieveData.phoneNo)) { //휴대폰번호 형식 체크 추가
          this.openAlertTemp(title, "휴대폰 번호 형식(10자리이상/최초입력번호: 01*)을 \n확인하여 주십시오");
          return;
        }                        
        this.openAlertPreTemp('inicis')
      },

      /**
       * Function    : inicisVerification
       * Description : 통합인증
       **/
      inicisVerification() {
         let title = '통합인증'
/*
         if(this.retrieveData.lgdBuyer.length < 1) {
          this.openAlertTemp(title, "이름을 입력해 주십시요");
          return;
        }

        if(this.birthday.length < 8) {
          this.openAlertTemp(title, "생년월일 8자리를 입력해 주십시요");
          return;
        }
*/

        let onetAutnDivsCd=this.$store.state.step1.onetAutnDivsCd
        let val=''
        if(onetAutnDivsCd === '10') val='PASS'
        else if(onetAutnDivsCd === '11')val='NAVER'
        else if(onetAutnDivsCd === '12')val='TOSS'
        /* [ST] KAKAO추가 2025-03-27 */
        else if(onetAutnDivsCd === '13')val='KAKAO'
        /* [ED] KAKAO추가 2025-03-27 */
          let params = {
            userName: this.retrieveData.lgdBuyer,
            userBirth: this.birthday,
            userPhone: this.retrieveData.phoneNo,
            onetMblAppfNo: this.registration.appfNo,
            dealCd: this.retrieveData.dealCd,
            directAgency :val
      }

          callInicisPopup(params).then(res => {

            if (res === 'SUCCESS') {
                  this.verificationCheck = true
                  this.openAlert(title, "인증 되었습니다.")
  
            } else {
              this.openAlertTemp(title, "인증처리중 오류가 발생했습니다")
            }
          });
      }

    }
  }
</script>

<style scoped></style>
